export const LOADING_SCREEN_START_TIME = 'loadingScreenStartTime';
